import { SkeletonPage } from "@/components/SkeletonLoaders.jsx";
import { lazy, Suspense } from "react";

// eslint-disable-next-line react/display-name
const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<SkeletonPage />}>
    <Component {...props} />
  </Suspense>
);

// sports module elements
const SportsListPage = Loadable(
  lazy(() => import("../containers/Sports/pages/SportsListPage"))
);
const SportsGroundListing = Loadable(
  lazy(() => import("../containers/Sports/SportsGroundListing/index.jsx"))
);
const SportsDetail = Loadable(
  lazy(() => import("../containers/Sports/SportsDetail/index.jsx"))
);
const SportsSlotBook = Loadable(
  lazy(() => import("../containers/Sports/pages/SportsSlotBook"))
);
const BookingSummary = Loadable(
  lazy(() => import("../containers/Sports/BookingSummary/index.jsx"))
);
const NotFound = Loadable(lazy(() => import("../components/NotFound")));
const SportsSelect = Loadable(
  lazy(() => import("../containers/Sports/SportsSelect/index.jsx"))
);
const GroundBookingConfirm = Loadable(
  lazy(() => import("../containers/Sports/GroundBookingConfirm"))
);

// bookings
export const MyBookings = Loadable(
  lazy(() => import("../components/bookings-status"))
);
export const BookingCancel = Loadable(
  lazy(() => import("../components/booking-cancel"))
);

// dashboard
export const ProviderDashboard = Loadable(
  lazy(() => import("../components/provider-dashboard"))
);

// auth and verification
export const SignIn = Loadable(lazy(() => import("../components/signIn")));
export const SignUp = Loadable(lazy(() => import("../components/signUp")));
export const OtpVerify = Loadable(
  lazy(() => import("../components/otpVerify"))
);
export const AadhaarVerify = Loadable(
  lazy(() => import("../components/aadhaar-verify"))
);

// community
export const ListAllPost = Loadable(
  lazy(() => import("@/components/community/ListAllPost.jsx"))
);
export const UserProfile = Loadable(
  lazy(() => import("@/components/community/UserProfile.jsx"))
);
export const ReportPost = Loadable(
  lazy(() => import("@/components/community/ReportPost.jsx"))
);
export const CreatePost = Loadable(
  lazy(() => import("@/components/community/CreatePost.jsx"))
);

export const UserConnections = Loadable(
  lazy(() => import("@/components/community/UserConnections.jsx"))
);

// eslint-disable-next-line react-refresh/only-export-components
export const routeElements = {
  // sports module elements
  sports: {
    home: <SportsListPage />,
    groundListing: <SportsGroundListing />,
    providerDetail: <SportsDetail />,
    slotBook: <SportsSlotBook />,
    bookingSummary: <BookingSummary />,
    providerSelect: <SportsSelect />,
    bookingConfirm: <GroundBookingConfirm />,
  },
  // other elements
  notFound: <NotFound />,
};
